<div class="row form" *ngIf="book != null">
  <app-loading-modal></app-loading-modal>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-4">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle reserva</h4>
        </div>
        <div class="col-sm-8 form__head__boxBtn">
          <button class="btn btn-sm btn-primary" (click)="edit(book.booking_id)"><i
              class="fas fa-pen-alt m-r-2"></i>Editar
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-50" id="body">
      <div class="card-body faq-box boder-left-dark">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
              <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Estado</div>
                <div class="child-right">
                  <span class="badge f-s-12 badge-{{book.status_class}}">{{book.checkin_status}}</span>
                </div>
              </div> -->
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Código reserva</div>
                <div class="child-right">
                  <span class="bold">{{book.code}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left bold">Titular Reserva</div>
                <div class="child-right">
                  {{book.client_data.fullname}}
                  <p class="bold f-s-10 m-b-0">DOC :
                    {{book.client_data.document}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 p-0 m-b-20">
          <p class="form__group__title m-b-0 f-s-14">
            <i class="fas fa-bed m-r-3"></i>Detalle Habitaciones
          </p>

          <div class="col-lg-12 row m-t-10">
            <ng-container *ngIf="detail_bedrooms.length == 0">
              Aun no se han agregado habitaciones
            </ng-container>
            <ng-container *ngIf="detail_bedrooms.length > 0">
              <ng-container *ngFor="let item of detail_bedrooms; let index = index">
                <div class="m-b-5">
                  <i class="far fa-calendar-alt m-r-5"></i>
                  {{index+1}}° Bloque Habitaciones
                </div>
                <div class="table-responsive m-b-15">
                  <table class="table mb-0 table-sm">
                    <thead class="thead-default">
                      <tr>
                        <th class="text-center">N° HAB</th>
                        <th>Tipo Hab.</th>
                        <th class="text-center">N°Pax</th>
                        <th>Check-In</th>
                        <th>Check-Out</th>
                        <th class="text-center">Noches</th>
                        <th class="text-right">Subtotal</th>
                        <th class="text-center"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="item.bedroom_selecteds.length > 0">
                        <ng-container *ngFor="let bedroom of item.bedroom_selecteds; let index_ = index">
                          <tr>
                            <td class="text-center f-s-13 bold">
                              {{bedroom.code_number}}
                            </td>
                            <td class="bold">
                              {{bedroom.roomtype.description}}
                            </td>
                            <td class="text-center">
                              {{bedroom.nro_pax}}
                            </td>
                            <td>
                              {{bedroom.date_checkin | date: 'mediumDate'}}
                            </td>
                            <td>
                              {{bedroom.date_checkout | date: 'mediumDate'}}
                            </td>
                            <td class="text-center bold">
                              <span class="f-s-13">{{bedroom.number_nights}}</span>
                            </td>
                            <td class="text-right">
                              {{toolsService.momeySol()}}{{bedroom.subtotal}}
                            </td>
                            <td class="text-center">
                              <a class="btn btn-sm btn-outline-secondary m-r-10 f-s-11" data-toggle="modal"
                                data-target="#modalNights" (click)="detailRateBedroom(index,index_)">👁️</a>
                              <ng-container *ngIf="bedroom.is_checkin">
                                <span class="badge bg-checkin text-white f-s-10">Check-In</span>
                              </ng-container>
                            </td>
                          </tr>
                          <tr *ngIf="bedroom.detail_charges.length > 0" style="background: #f6fdff;">
                            <td></td>
                            <td colspan="5" class="ps-4 py-1 text-right">
                              <span class="m-r-5 f-s-11">
                                <strong>Extras agregados:</strong>
                              </span>
                              <ng-container *ngFor="let charge of bedroom.detail_charges; let index_charge = index">
                                <div class="input-group input-group-sm m-r-15"
                                  style="display: inline-flex; width: auto;">
                                  <span class="input-group-prepend">
                                    <span class="input-group-text f-s-11" style="background: transparent;">
                                      <span class="m-r-3">( <span class="bold">{{charge.quantity}}</span> )</span>
                                      {{charge.description}} | <span
                                        class="m-l-3">{{toolsService.momeySol()}}{{charge.price}}</span>
                                    </span>
                                  </span>
                                </div>
                              </ng-container>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </ng-container>

            </ng-container>
          </div>
        </div>

        <div class="col-12 p-0 m-b-20">
          <p class="form__group__title m-b-0 f-s-14">
            <i class="fas fa-users m-r-5"></i>Datos de huéspedes
          </p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Nombre</th>
                  <th>N° Documento</th>
                  <th>Grupo edad</th>
                  <th>Celular</th>
                  <th>Correo</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="detail_guests.length == 0">
                  <tr>
                    <td colspan="4"><span>Aun no se han agregado huéspedes</span></td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="detail_guests.length > 0">
                  <tr *ngFor="let item of detail_guests; let index_ = index">
                    <td>{{item.fullname}}</td>
                    <td>{{item.document}}</td>
                    <td>
                      {{item.age_group_description}}
                    </td>
                    <td>{{item.client_data.cellphone}}</td>
                    <td>{{item.client_data.email}}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-12 p-0 m-b-20">
          <p class="form__group__title m-b-0 f-s-14">
            <i class="fas fa-bus m-r-5"></i>Recojos/traslados
          </p>
          <ng-container *ngIf="detail_transfers.length == 0">
            <p>No se encontraron registros</p>
          </ng-container>
          <ng-container *ngIf="detail_transfers.length > 0">
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead class="thead-default">
                  <tr>
                    <th>TIPO transfer</th>
                    <th class="text-center">N°Pax</th>
                    <th>Procedencia/Destino</th>
                    <th>Referencia (#vuelo,empresa)</th>
                    <th>Fecha y Hora</th>
                    <th>Obs.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of detail_transfers; let index_ = index">
                    <td>
                      <ng-container *ngIf="item.typetransfer_id == 1">
                        <i class="fas fa-plane-arrival text-success m-r-5"></i> RECOJO
                      </ng-container>
                      <ng-container *ngIf="item.typetransfer_id == 2">
                        <i class="fas fa-plane-departure text-danger m-r-5"></i> TRASLADO
                      </ng-container>
                    </td>
                    <td class="text-center">
                      {{item.nro_pax}}
                    </td>
                    <td>
                      {{item.arrivalplace_data.description}}
                    </td>
                    <td>{{item.reference_place}}</td>
                    <td>{{item.date_transfer | date: 'mediumDate'}} - {{item.time_transfer}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>

        <div class="col-12 p-0 m-b-20">
          <p class="form__group__title m-b-0 f-s-14">
            <i class="fas fa-shopping-bag m-r-5"></i>Consumos/Servicios
          </p>
          <ng-container *ngIf="detail_sales.length == 0">
            <p>No se encontraron registros</p>
          </ng-container>
          <ng-container *ngIf="detail_sales.length > 0">
            <div class="table-responsive">
              <div id="accordion">

                <div class="card m-b-10" *ngFor="let item of detail_sales; let index = index">
                  <!-- HEADER -->
                  <div class="card-header p-8" [id]="'headingOne' + item.id" style="padding: 7px 10px;">
                    <h5 class="mb-0 mt-0 font-12">
                      <a data-toggle="collapse" data-parent="#accordion" [attr.href]="'#collapseOne' + item.id"
                        target="_self" aria-expanded="false" [attr.aria-controls]="'collapseOne' + item.id"
                        class="text-dark collapsed">
                        <div class="d-flex justify-content-between">
                          <div>
                            <span class="bold">
                              VENTA:
                              <span class="text-primary">{{item.code}}</span>
                            </span>
                          </div>
                          <div>
                            <span class="bold ">
                              HAB: {{item.detail_bedroom.bedroom.code_number}}
                            </span>
                          </div>
                          <div>
                            {{item.date_sale | date: 'mediumDate'}}
                          </div>
                          <div>
                            <span class="bold">
                              TOTAL VENTA : {{toolsService.momeySol()}}{{item.total}}
                            </span>
                            <span class="m-l-15 text-success bold">
                              <i class="fas fa-arrow-down"></i> Detalle
                            </span>
                          </div>
                        </div>
                      </a>
                    </h5>
                  </div>

                  <!-- COLLAPSE -->
                  <div class="collapse" [id]="'collapseOne' + item.id" [attr.aria-labelledby]="'headingOne' + item.id"
                    data-parent="#accordion">
                    <div class="card-body" style="padding: 10px; border-bottom: 1px solid #ced4da;
                                border-left: 1px solid #ced4da;
                                border-right: 1px solid #ced4da;">

                      <div class="table-responsive">
                        <table class="table table-sm mb-0">
                          <thead style="background-color: #eaf9ff;">
                            <tr>
                              <th>Código</th>
                              <th>Nombre producto</th>
                              <th class="w-15 text-center">U. Medida</th>
                              <th class="w-15 text-right">Cantidad</th>
                              <th class="w-15 text-right">P. Venta unitario</th>
                              <th class="w-15 text-right">Total Igv</th>
                              <th class="w-15 text-right">Subtotal</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let detail of item.detail">
                              <td>{{detail.product.code}}</td>
                              <td>{{detail.product.description}}</td>
                              <td class="w-15 text-center">{{detail.unitmeasure.description}}</td>
                              <td class="w-15 text-right">{{detail.quantity}}</td>
                              <td class="w-15 text-right">{{detail.price}}</td>
                              <td class="w-15 text-right">
                                <span *ngIf="detail.igv == null">0</span>
                                <span *ngIf="detail.igv != null">{{detail.igv}}</span>
                              </td>
                              <td class="w-15 text-right">
                                <span class="bold">{{toolsService.momeySol()}}{{detail.subtotal}}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                    </div>
                  </div>

                </div>

              </div>
            </div>
          </ng-container>
        </div>


        <div class="col-12 m-t-20 p-0">
          <p class="form__group__title m-b-0 f-s-14"><i class="fas fa-info-circle m-r-5"></i>RESUMEN TOTALES
            S/</p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead style="background: #ffffea;">
                <tr>
                  <th class="text-center">TOTAL HABITACIONES</th>
                  <th class="text-center">TOTAL CONSUMOS</th>
                  <th class="text-center">
                    <span class="text-primary">TOTAL RESERVA</span>
                  </th>
                  <th class="text-right">
                    <span class="text-success">PAGADO</span>
                  </th>
                  <th class="text-right">
                    <span class="text-danger">DEUDA</span>
                  </th>
                  <th class="text-right">
                    <span class="text-info">FACTURADO</span>
                  </th>
                </tr>
              </thead>
              <tbody style="background: #ffffea;">
                <tr>
                  <td class="text-center f-s-13 bold">{{toolsService.momeySol()}}{{total_bedrooms| number:'1.2-2'}}</td>
                  <td class="text-center f-s-13 bold">{{toolsService.momeySol()}}{{total_sales| number:'1.2-2'}}</td>
                  <td class="text-center f-s-13 bold">
                    <span class="text-primary">{{toolsService.momeySol()}}{{total | number:'1.2-2'}}</span>
                  </td>
                  <td class="text-right">
                    <span
                      class="text-success bold">{{toolsService.momeySol()}}{{book.total_paid | number:'1.2-2'}}</span>
                  </td>
                  <td class="text-right">
                    <span
                      class="text-danger bold">{{toolsService.momeySol()}}{{total - book.total_paid | number:'1.2-2'}}</span>
                  </td>
                  <td class="text-right">
                    <span class="text-info bold">{{book.total_billing | number:'1.2-2'}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 
        <div class="col-12 m-t-20 p-0">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-money-bill-alt m-r-5"></i>Comprobantes y
            cobros realizados</p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Tipo comprobante</th>
                  <th>N° comprobante</th>
                  <th>Fecha</th>
                  <th class="w-15 text-center">Método pago</th>
                  <th class="w-15 text-right">Pagado</th>
                  <th class="w-15 text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-if="movements.length==0">
                  <td colspan="7">No registra datos de cobros.</td>
                </tr>
                <tr ng-repeat="item in movements" ng-if="movements.length > 0">
                  <td>[[item.typevoucher]]</td>
                  <td>[[item.nro_voucher]]</td>
                  <td>[[item.date_movement | dateFormatShort]]</td>
                  <td class="w-15 text-center">[[item.paymethod]]</td>
                  <td class="w-15 text-right">[[item.total_amount | currency:'S/.']]</td>
                  <td class="w-15 text-center">
                    <div ng-if="item.date_repayment == null">
                      <a title="[[item.typevoucher]]" class="text-warning pointer bold" target="_blank"
                        href="/print/billing/document/[[item.id]]"
                        ng-if="item.voucher_id == voucher_ruc || item.voucher_id == voucher_boleta || item.voucher_id == voucher_ordernote">
                        <i class="fas fa-print f-s-16"></i>
                      </a>
                      <a title="[[item.typevoucher]]" class="text-warning pointer bold" target="_blank"
                        href="/print/income/document/[[item.id]]"
                        ng-if="item.voucher_id == voucher_income || item.voucher_id == voucher_expense">
                        <i class="fas fa-print f-s-16"></i>
                      </a>
                    </div>
                    <div ng-if="item.date_repayment != null">
                      <span class="badge badge-danger f-s-11">Anulado</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
         -->



      </div>
    </div>
  </div>

  <!-- Modal detalle de noches -->
  <div id="modalNights" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header" *ngIf="bedroomSelected != null">
          <h5 class="modal-title">Detalle — <strong> HAB {{bedroomSelected.code_number}} :
              {{bedroomSelected.roomtype.description}}</strong></h5>
          <a type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="removedetailRateBedroom()">
            <span aria-hidden="true">&times;</span>
          </a>
        </div>
        <div class="modal-body modal-night" *ngIf="bedroomSelected != null">
          <table class="table table-bordered">
            <thead class="thead-default">
              <tr>
                <th>Fecha</th>
                <!-- <th>Tipo Tarifa</th> -->
                <th class="text-center">Tarifa x noche</th>
                <th>Origen Tarifa</th>
                <!-- <th>Tipo tarifa</th> -->
                <!-- <th>Extra aplicado</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rate of bedroomSelected.daily_rates; let index = index">
                <td>{{rate.date | date: 'mediumDate'}}</td>
                <!-- <td>{{typeRateObj.description}}</td> -->
                <td class="text-center">{{toolsService.momeySol()}}{{rate.rate}}</td>
                <td>
                  <ng-container *ngIf="rate.origin == 'base'">Config.Tipo Habitación</ng-container>
                  <ng-container *ngIf="rate.origin == 'season'">Config.Temporada</ng-container>
                  <ng-container *ngIf="rate.origin == 'agreement'">Config.Convenio</ng-container>
                </td>
              </tr>
            </tbody>
          </table>

          <ng-container *ngIf="bedroomSelected.detail_charges.length > 0">
            <table class="table table-bordered m-t-15">
              <thead class="thead-default">
                <tr>
                  <th>Extras agregados <i class="fas fa-plus text-success m-l-4"></i></th>
                  <th class="text-center">Cant.</th>
                  <th>Tarifa</th>
                  <th>SubTotal</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let charge of bedroomSelected.detail_charges">
                  <td>{{charge.description}}</td>
                  <td class="text-center">{{charge.quantity}}</td>
                  <td>{{toolsService.momeySol()}}{{charge.price}} * ({{bedroomSelected.number_nights}} noches)</td>
                  <td>{{toolsService.momeySol()}}{{(charge.price*charge.quantity)*bedroomSelected.number_nights}}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>

        </div>
        <div class="modal-footer" *ngIf="bedroomSelected != null">
          <div class="me-auto bold f-s-15 m-r-15">TOTAL HABITACIÓN:
            {{toolsService.momeySol()}}{{bedroomSelected.subtotal}}
          </div>
          <button type="button" class="btn btn-secondary" data-dismiss="modal"
            (click)="removedetailRateBedroom()">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <!-- =============== -->
</div>
